/**
 * После обрезки последней строки в конце могут остаться пробелы, или знаки припинания
 * или кусок слова, состоящий из одной буквы. Это регулярное выражение удаляет их.
 * @type {RegExp}
 */
export var PRETTIFY_LAST_ROW_REGEXP = /[({['".:,\s\t\-_]+[\wа-яё]?$/i;

/**
 * Вставляется в конец обрезанного текста
 * @type {String}
 */
export var OVERFLOW_SIGN = '...';

/**
 * Допустимая погрешность длины строки (px)
 * @type {Number}
 */
export var EPSILON = 10;